import { default as setting } from './setting/routes'

export default [
    ...setting
]